// Coming back after a dropped connection. A player's report: "When I got
// disconnected and then rejoined the game my controls didn't work any
// more." Every join is a brand-new connection with a brand-new id, and the
// host's seats were tied to the old one - so the rejoined computer's
// presses matched no seat, and a phone was told the game was full.
//
// So each tab keeps one id for as long as it is open (a reload keeps it
// too), sends it when joining, and the host hands that tab's old seats to
// its new connection.

const CLIENT_KEY = 'couchBlocks:client';

export function clientId() {
  try {
    let id = window.sessionStorage.getItem(CLIENT_KEY);
    if (!id) {
      id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      window.sessionStorage.setItem(CLIENT_KEY, id);
    }
    return id;
  } catch {
    return null; // no storage: every join is a stranger, as before
  }
}

/**
 * Moves every seat that belonged to one of `oldPeers` over to `newPeer`,
 * in place, keeping its place in the well. `keyFor(peer, device)` makes a
 * seat key. Returns { oldKey: newKey } for each seat moved.
 */
export function handOverSeats(seats, oldPeers, newPeer, keyFor) {
  const moved = {};
  seats.forEach((seat) => {
    if (!oldPeers.includes(seat.peer)) return;
    const key = keyFor(newPeer, seat.device);
    moved[seat.key] = key;
    seat.peer = newPeer;
    seat.key = key;
  });
  return moved;
}
